module.exports = __webpack_public_path__ + "img/Variable-Flavor-Remix1.2f70432c.png";